import { useScrollReveal } from '../../../hooks/useScrollReveal';

const clients = [
  { name: 'Soluplex', logo: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/991a9c4727aedbc5d8d4e32f9add6dd3.png' },
  { name: 'DMD', logo: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/fa975fe32ef9c52c3fecd82744160854.png' },
  { name: 'Grupo K', logo: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/2bb0fc45f8a5317b725476f02b7d253b.png' },
  { name: 'Fiat', logo: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/f8f60a9a66f165d368ad45222eb0ba20.png' },
  { name: 'Natura', logo: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/4937adc1893dd9325dfde1f0e6ae4b91.png' }
];

export function Clients() {
  const titleRef = useScrollReveal();
  const logo1Ref = useScrollReveal();
  const logo2Ref = useScrollReveal();
  const logo3Ref = useScrollReveal();
  const logo4Ref = useScrollReveal();
  const logo5Ref = useScrollReveal();

  const logoRefs = [logo1Ref, logo2Ref, logo3Ref, logo4Ref, logo5Ref];

  return (
    <section id="clientes" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={titleRef} className="text-center mb-16 scroll-reveal">
          <h2 className="text-5xl font-black text-white mb-4">Eles escolheram a GUEPARDO. Só falta você!</h2>
          <p className="text-xl text-gray-400 font-medium">GUEPARDO AGENCIA</p>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-200 to-amber-100 mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {clients.map((client, index) => (
            <div
              key={index}
              ref={logoRefs[index]}
              className="bg-gray-900 rounded-xl p-6 shadow-md hover:shadow-xl hover:shadow-amber-200/20 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center cursor-pointer group border border-gray-800 scroll-reveal-scale"
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <img
                src={client.logo}
                alt={client.name}
                className="w-full h-auto object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}